

























































































































import { Component } from "vue-property-decorator";
import { dateFilter, timeFilter } from "@/utils/date-util";
import { CallGroupIncomingItem } from "@/store/call/statistic/types";
import BaseItemsPage from "../BaseItemsPage";
import CallGroupIncomingFilter from "@/components/Call/Statistic/CallGroupIncomingFilter.vue";
import { ScrollButton } from "wings-ui-components";
import { Getter } from "vuex-class";
import GroupCharts from "@/components/Statistics/GroupCharts.vue";

@Component({
  components: {CallGroupIncomingFilter, ScrollButton, GroupCharts},
  filters: {dateFilter, timeFilter},
})
export default class CallGroupIncoming extends BaseItemsPage<CallGroupIncomingItem> {

  @Getter("callStatisticGroupIncoming") responseItems?: CallGroupIncomingItem[];
  @Getter("callGroupByIncoming") groupByList: any;

  is_show_filter = true;
  is_show_graphics = true;
  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData() {
    return this.responseItems;
  }

  get tableFieldsDefault() {
    return ['finished', 'failed', 'total', 'duration'];
  }

  get totalData() {
    let total = {
      totalRow: 'This is the last row of the table',
      finished: 0,
      failed: 0,
      total: 0,
      duration: 0,
    };
    this.tableData.forEach( (row: CallGroupIncomingItem) => {
      total.finished += row.finished;
      total.failed += row.failed;
      total.total += row.total;
      total.duration += row.duration;
    });
    return total;
  }

  get compareData() {
    return [...this.queriedData, this.totalData];
  }

  itemColor(item: CallGroupIncomingItem){
    if (item.finished / item.total * 100 < 50) return 'color-danger';
    if (item.finished / item.total * 100 < 85) return 'color-warning';
    if (item.finished / item.total * 100 < 100) return 'color-success';
    return 'color-success'
  }

}
